<div class="resumo__total__label" *ngIf="tipoRelatorio !== '4'">
  <p>RESUMO TOTAL</p>
</div>
<div>
  <ng-content></ng-content>
</div>
<div class="valor__fatura">
  <p>VALOR TOTAL DA FATURA R$ {{ valorTotalDaFatura }}</p>
</div>
<div class="espaco__branco">

</div>